// removed by extract-text-webpack-plugin
module.exports = {"breakpoint-not-small":"screen and (min-width: 30em)","breakpoint-small-medium":"screen and (max-width: 45em)","breakpoint-medium":"screen and (min-width: 30em) and (max-width: 60em)","breakpoint-large":"screen and (min-width: 60em)","breakpoint-small":"screen and (max-width: 30em)"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/style/app.scss
// module id = 5inX
// module chunks = 17